import { RouterProvider } from 'react-router-dom'

import Spinner from '@/components/Spinner'
import { useInitAuth } from '@/hooks/useInitAuth'
import router from '@/router'

export default function App() {
  const { authStatus } = useInitAuth()

  if (authStatus === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100dvh' }}>
        <Spinner size='medium' />
      </div>
    )
  }

  return <RouterProvider router={router} />
}
